import {
  UNDEFINED_STATUS
} from './action-status';

import {
  MACHINE_TABLE_TYPE
} from './active-content-type';

export default function initialState() {
  return {
    moduleName: 'wr-dashboard',
    storageSpace: { used: 0, total: 0 },
    setupArchivePasswordStatus: UNDEFINED_STATUS,
    archiveDeletionStatus: UNDEFINED_STATUS,
    contentItems: [],
    fetchStorageSpaceStatus: UNDEFINED_STATUS,
    fetchContentItemsStatus: UNDEFINED_STATUS,
    activeContentType: MACHINE_TABLE_TYPE,
    appFeatures: { notaryEnabled: false, asignEnabled: false, notaryUrl: '' },
    fileVersions: [],
    fetchFileVersionsStatus: UNDEFINED_STATUS,
    signFileLink: '',
    signFileStatus: UNDEFINED_STATUS,
    searchEnabled: false,
    searchResultReceived: false,
    activeVersionPath: '',
    activeVolumePath: '',
    activeFolderItem: { path: '', displayName: '', isSearchFolder: false },
    fetchContainerItemsStatus: UNDEFINED_STATUS,
    machines: [],
    backups: [],
    incompleteBackups: [],
    incompleteBackupsCount: 0,
    incompleteBackupsSize: 0,
    totalUsedSpace: 0,
    activeMachineId: '',
    activeMachineDisplayName: '',
    incompleteBackupsMachineId: 'c0e5abbeeefc452ca4ef40a776e5882fc0e5abbe',
    fetchBackupsStatus: UNDEFINED_STATUS,
    activeBackupId: '',
    activeBackupDisplayName: '',
    deleteAllIncompleteStatus: UNDEFINED_STATUS,
    displayUserName: '',
    postLoginOpenMachineId: { id: '', baseName: '', machineId: '' },
    postLoginMachineName: '',
    postLoginArchiveObId: ''
  };
}
